// Manage Teams
import { manageTeams, manageTeamsConfig } from './manage.teams.js'

export default function manageTeamsRoutes($stateProvider) {
  'ngInject'
  $stateProvider.state(manageTeams, manageTeamsConfig)
}
